/* eslint-disable @typescript-eslint/no-explicit-any */
import { resolve } from 'path';
import Core from '../core';
import { reject } from 'lodash';
import browserTimeZone from './localtime';
import { AxiosRequestConfig } from 'axios';

function getFullPathProfilePic(userId: number, options?: AxiosRequestConfig) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(`v1/employee/getImage?user_id=${userId}`, options)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getCountries() {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/location/selectCountries?locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function empStatus(empId: number, companyId: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .post(
        `/v1/employee/empStatus?emp_id=${empId}&company_id=${companyId}&locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getCurrentEmpStatus(
  empId: number,
  companyId: number,
  options?: AxiosRequestConfig,
) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/employee/getEmpStatus?emp_id=${empId}&company_id=${companyId}`,
        options,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function logout(user_session_id: any) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .post(`/logout?user_sessions_id=${user_session_id}`)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch(() => {
        reject(null);
      });
  });
}

function getStates(id: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/location/selectStates/id/${id}?locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getCompanyGenders(companyId: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/company/getGenders?company_id=${companyId}&locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getCompanyMaritalStatus(companyId: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/company/getMaritalStatus?company_id=${companyId}&locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getAllCompanyDepartments(companyId: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/department/select?companyId=${companyId}&locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getCompanyEmployeeTypes(companyId: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/company/getEmployeeTypes?company_id=${companyId}&locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getWorkflow(instanceId: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/machine/history/instance?id=${instanceId}&locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getPendingWorkflow(id: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/machine/history/instance/pendingWith?id=${id}&locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getCompanyContractTypes(companyId: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/company/getContractTypes?company_id=${companyId}&locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getCompanyEmployeeCategories(companyId: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/company/getEmployeeCategories?company_id=${companyId}&locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getCompanyPayrollTypes(companyId: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/company/getPayrollTypes?company_id=${companyId}&locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getAllCompanyGovTaxes(companyId: number) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(`/v1/governmentTax?company_id=${companyId}`)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function updateProfilePic(payload: any) {
  const api = Core.getInstance().apiforImageUp();

  return new Promise((resolve, reject) => {
    api
      .post(`/v1/user/updatePic`, payload)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getCalendarData(
  companyId: number,
  empId: number,
  month: number,
  year: number,
) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/getEmployeeLeavesCalandar?company_id=${companyId}&emp_id=${empId}&month=${month}&year=${year}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getAttendanceCalendar(
  companyId: number,
  empId: number,
  month: number,
  year: number,
) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/emp/attendances/calendars?company_id=${companyId}&emp_id=${empId}&month=${month}&year=${year}`,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getDownloadableFile(image: string) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(`/v1/file/downloadForEmpPortal?image=${image}`)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getEmpTicketTypes(id: any) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(`/v1/business/types?trip_type_id=${id}`)
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function getActiveCompanyEmployees(id: any) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/getActiveCompanyEmployees?companyId=${id}&all=0&locale=${localStorage.getItem(
          'emplang',
        )}
      `,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function getPayoutBankFields(companyId: any) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/config/payout/bankTypes?companyId=${companyId}&locale=${localStorage.getItem(
          'emplang',
        )}
      `,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function getPayoutExchangeFields(companyId: any) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `v1/config/payout/exchangeTypes?companyId=${companyId}&locale=${localStorage.getItem(
          'emplang',
        )}
      `,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function getBankNameList(companyId: any) {
  const api = Core.getInstance().api();

  return new Promise((resolve, reject) => {
    api
      .get(
        `v1/getBankNameList?companyID=${companyId}&locale=${localStorage.getItem(
          'emplang',
        )}
      `,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function getFilePath(CompanyID: number, user_id: number, Payload: any) {
  const api = Core.getInstance().apiforImageUp();

  if (!Payload) return new Promise((resolve) => resolve(null));

  return new Promise((resolve, reject) => {
    api
      .post(
        `/v2/company/getSignedFilepath?companyId=${CompanyID}&userId=${user_id}`,
        Payload,
      )
      .then((response) => {
        if (response.status === 200) {
          return resolve(response.data.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function exportAll(Payload: any) {
  const api = Core.getInstance().api();
  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/export?company_id=${Payload.company_id}&event=${
          Payload.event
        }&user=${Payload.user_id}&emp_id=${Payload.emp_id}&from_date=${
          Payload.from_date
        }&to_date=${
          Payload.to_date
        }&app=2
        &timeZone=${browserTimeZone}&locale=${localStorage.getItem(
          'emplang',
        )}`,
      )
      .then((result) => {
        return resolve(result.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}
export const commonServices = {
  getCountries,
  getCompanyGenders,
  getCompanyMaritalStatus,
  getAllCompanyDepartments,
  getCompanyEmployeeTypes,
  getCompanyContractTypes,
  getCompanyEmployeeCategories,
  getCompanyPayrollTypes,
  getAllCompanyGovTaxes,
  getFullPathProfilePic,
  updateProfilePic,
  getWorkflow,
  getPendingWorkflow,
  getCalendarData,
  getAttendanceCalendar,
  getStates,
  logout,
  empStatus,
  getCurrentEmpStatus,
  getDownloadableFile,
  getEmpTicketTypes,
  getActiveCompanyEmployees,
  getPayoutBankFields,
  getPayoutExchangeFields,
  getBankNameList,
  getFilePath,
  exportAll,
};
